import http from '@/http/aisea/axios'
import moment from 'moment-timezone';
const resource = "/enterprises/crews";

export default {

  search(enterpriseCrewId, payload) {
    return http.get(`${resource}/${enterpriseCrewId}/timesheet`, {
      params: payload
    });
  },

  fetch(enterpriseCrewId, id) {
    return http.get(`${resource}/${enterpriseCrewId}/timesheet/${id}`);
  },

  add(enterpriseCrewId, payload) {
    payload.now = moment().local().format('YYYY-MM-DD');
    return http.post(`${resource}/${enterpriseCrewId}/timesheet`, payload);
  },

  update(enterpriseCrewId, id, payload) {
    payload.now = moment().local().format('YYYY-MM-DD');
    return http.put(`${resource}/${enterpriseCrewId}/timesheet/${id}`, payload);
  },

  delete(enterpriseCrewId, id, payload) {
    return http.delete(`${resource}/${enterpriseCrewId}/timesheet/${id}`, {data: payload});
  },
};
